import React from 'react';
import CircularProgress from 'material-ui/CircularProgress';
import classnames from 'classnames';
import classes from '../../kickstarter-shipping-popup.scss';
export default function KickstarterShippingCSVLoader({
  onCSVUpload,
  uploadState,
  error
}) {
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("section", {
    className: classes.popupHeader
  }, /*#__PURE__*/React.createElement("span", {
    className: classes.KSLabel
  }, "KICKSTARTER")), /*#__PURE__*/React.createElement("p", {
    className: classes.popupContent
  }, "To proceed with the Swag.com fulfillment option, we\u2019ll need you to upload your Kickstarter backer report. This .CSV file includes all of the details you requested in your backer survey, including your backers addresses, t-shirt size preferences, etc.", /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("a", {
    className: classes.link,
    href: "/assets/csv/kickstarter-shipping-sample.csv"
  }, "View sample .CSV file")), /*#__PURE__*/React.createElement("p", {
    className: classes.popupContent
  }, "You will be able to view all of your tracking information from your Swag.com Dashboard."), /*#__PURE__*/React.createElement("div", {
    className: classnames(classes.popupActions, classes.uploadButton, {
      [classes.isLoading]: uploadState === 'loading'
    })
  }, /*#__PURE__*/React.createElement("label", {
    className: classes.uploadButtonLabel
  }, /*#__PURE__*/React.createElement("span", {
    className: classes.uploadButtonText
  }, "Upload CSV"), uploadState === 'loading' &&
  /*#__PURE__*/
  // @ts-ignore
  React.createElement(CircularProgress, {
    className: classes.loader,
    color: '#fff',
    size: 60
  }), /*#__PURE__*/React.createElement("input", {
    className: classes.uploadInput,
    onChange: onCSVUpload,
    type: "file",
    accept: ".csv,text/csv,text/plain"
  }))), error && error !== '' && /*#__PURE__*/React.createElement("div", {
    className: classes.error
  }, error));
}